import React, { useState } from "react";
import HorizontalScroll from "../common/HorizontalScroll";
import {
  IoIosAddCircleOutline,
  IoIosRemoveCircleOutline,
} from "react-icons/io";
import { MdOutlineArticle } from "react-icons/md";
import Checkbox from "../common/Checkbox";
import { LiaDownloadSolid } from "react-icons/lia";

export default function ProceduresPopup() {
  const [data, setData] = useState([
    {
      title: "SN2_526_M_TA03",
      isExpand: true,
      checked: false,
      children: [
        { number: 10, checked: false },
        { number: 20, checked: false },
        { number: 30, checked: false },
      ],
    },
    {
      title: "SN2_526_M_TA04",
      isExpand: false,
      checked: false,
      children: [
        { number: 10, checked: false },
        { number: 20, checked: false },
        { number: 30, checked: false },
      ],
    },
  ]);

  // ✅ Toggle expand/collapse
  const toggleExpand = (idx) => {
    setData((prev) =>
      prev.map((item, i) =>
        i === idx ? { ...item, isExpand: !item.isExpand } : item
      )
    );
  };

  // ✅ Handle parent checkbox
  const handleParentCheck = (idx, checked) => {
    setData((prev) =>
      prev.map((item, i) =>
        i === idx
          ? {
              ...item,
              checked,
              children: item.children.map((c) => ({ ...c, checked })),
            }
          : item
      )
    );
  };

  // ✅ Handle child checkbox
  const handleChildCheck = (parentIdx, childIdx, checked) => {
    setData((prev) =>
      prev.map((item, i) => {
        if (i === parentIdx) {
          const updatedChildren = item.children.map((c, j) =>
            j === childIdx ? { ...c, checked } : c
          );
          const allChecked = updatedChildren.every((c) => c.checked);
          return { ...item, children: updatedChildren, checked: allChecked };
        }
        return item;
      })
    );
  };

  // ✅ Handle "Select All" checkbox
  const handleSelectAll = (checked) => {
    setData((prev) =>
      prev.map((item) => ({
        ...item,
        checked,
        children: item.children.map((c) => ({ ...c, checked })),
      }))
    );
  };

  const allChecked = data.every((p) => p.checked);
  return (
    <div className="p-2.5 pb-5 flex flex-col gap-[13px]">
      <HorizontalScroll
        className="w-full"
        overflow="overflow-auto  max-h-[300px]"
      >
        <div className="">
          <div>
            {" "}
            <HorizontalScroll className="w-full">
              {" "}
              <table className="flex-1 w-full text-[12px] text-[#242424] text-center border border-[#C9C9C9]/30 whitespace-nowrap relative max-h-[300px]">
                <thead>
                  <tr className="font-normal divide-x divide-[#C9C9C9]/30 bg-[#DBDBDB] sticky top-[-1px]">
                    <th className="py-1 px-2.5 font-normal">
                      <Checkbox
                        color="#1C1B1F"
                        borderColor="border-[#1C1B1F]"
                        checked={allChecked}
                        onChange={(val) => handleSelectAll(!allChecked)}
                      />
                    </th>
                    <th className="py-1 px-2.5 font-normal">순서</th>
                    <th className="py-1 px-2.5 font-normal">값</th>
                    <th className="px-2.5 font-normal">
                      태그 <br />
                      설정
                    </th>
                    <th className="px-2.5 font-normal">
                      태그 <br />
                      해제
                    </th>
                    <th className="px-2.5"></th>
                  </tr>
                </thead>

                <tbody>
                  {data.map((it, idx) => (
                    <React.Fragment key={idx}>
                      {/* Parent Row */}
                      <tr
                        className="bg-white cursor-pointer hover:bg-[#f8f8f8] border-t border-[#C9C9C9]/30 divide-x divide-[#C9C9C9]/30"
                        onClick={() => toggleExpand(idx)}
                      >
                        <td
                          className="py-1.5 px-2.5 text-center"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Checkbox
                            color="#1C1B1F"
                            borderColor="border-[#1C1B1F]"
                            checked={it.checked}
                            onChange={(val) => handleParentCheck(idx, val)}
                          />
                        </td>
                        <td className="py-1.5 px-2.5 text-center"></td>
                        <td className="py-1 px-2.5 text-left">
                          <span className="flex items-center gap-[5px]">
                            {it.isExpand ? (
                              <IoIosRemoveCircleOutline size={16} />
                            ) : (
                              <IoIosAddCircleOutline size={16} />
                            )}
                            {it.title}
                          </span>
                        </td>
                        <td className="py-1 px-2.5"></td>
                        <td className="py-1 px-2.5"></td>
                        <td className="py-1 px-2.5"></td>
                      </tr>

                      {/* Child Rows */}
                      {it.isExpand &&
                        it.children.map((child, idx2) => (
                          <tr
                            key={idx2}
                            className="bg-[#F1F1F1] font-light border-t border-[#C9C9C9]/30 divide-x divide-[#C9C9C9]/30"
                          >
                            <td
                              className="py-1.5 px-2.5 text-center"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Checkbox
                                color="#1C1B1F"
                                borderColor="border-[#1C1B1F]"
                                checked={child.checked}
                                onChange={(val) =>
                                  handleChildCheck(idx, idx2, val)
                                }
                              />
                            </td>
                            <td className="py-1.5 px-2.5">{child.number}</td>
                            <td className="py-1 px-2.5 text-left">
                              <span className="flex items-center gap-[5px]">
                                <MdOutlineArticle size={16} />
                                {child.number}-526-J-HS-3722
                              </span>
                            </td>
                            <td className="py-1 px-2.5">OFF</td>
                            <td className="py-1 px-2.5">OFF</td>
                            <td className="py-1 px-2.5">주급수펌프</td>
                          </tr>
                        ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </HorizontalScroll>
          </div>
        </div>
      </HorizontalScroll>

      <button className="bg-[#08F] w-[102px] rounded-[3px] p-1.5 flex items-center justify-center ml-auto">
        <LiaDownloadSolid color="#fff" size={20} />
      </button>
    </div>
  );
}
